import dayjs from 'dayjs'
import { defineComponent, watch } from 'vue'
import { RouterView } from 'vue-router'

import 'dayjs/locale/en'
import 'dayjs/locale/th'

import AppLoading from './components/common/loading/AppLoading'
import VToast from './components/feedback/toast/VToast'
import VNavbar from './components/layouts/navbar/VNavbar'
import useAuth from './composables/auth/useAuth'
import useBreakpoints from './composables/common/useBreakpoints'
import useLocalization from './composables/localization/useLocalization'
import useNavbar from './composables/navbar/useNavbar'

export default defineComponent(() => {
  // #region Global Composables

  const auth = useAuth()
  useBreakpoints()
  useNavbar()
  const localization = useLocalization()

  // #endregion

  // #region Watchers

  watch(() => [auth.userProfile?.language_preference, localization.loginLocaleCode.value], () => {
    if (auth.userProfile !== null) {
      dayjs.locale(auth.userProfile.language_preference)
    } else {
      dayjs.locale(localization.loginLocaleCode.value)
    }
  }, {
    immediate: true
  })

  // #endregion

  localization.reset()

  return () => (
    <>
      <AppLoading />
      <VToast />
      <VNavbar />
      <RouterView />
    </>
  )
}, {
  name: 'App'
})
